import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';

export enum ItemsSubmitType {
  Select = 'select',
  Buy = 'buy',
}

export type TTrackMediaManagerFileChosenInfo = {
  items: MediaManagerSDKAnyItem[];
  target: ItemsSubmitType;
  category: string;
  categoryId: string;
  searchTerm: string;
  orientation: string;
  fileType: string;
};

export interface IWithItemsSubmittedAnalyticsOuter {
  fileType: string;
}

export interface IWithItemsSubmittedAnalyticsInner {
  trackMediaManagerFileChosen: (options: TTrackMediaManagerFileChosenInfo) => void;
  trackMediaManagerFileChosenTry: (items: MediaManagerSDKAnyItem[]) => void;
}
